import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import horseUrlBuilder from './urlBuilder';

const ColumnStallionName = (props) => {
    if (props.data) {
        const shouldBreakWord = !/\s/.test(props.data);
        return (
            <span className={`sb-stallionName ${shouldBreakWord ? 'word-break' : ''}`}>
                <a
                    href={horseUrlBuilder(props.rowData.horse_uid, props.rowData.style_name)}
                    className="js-popupLink ui-link ui-link_table"
                >
                    {props.data}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
                    {(() => {
                        if (props.rowData.weatherbys_uid) {
                            return (
                                <Svg
                                    size="Medium"
                                    iconName="weatherby"
                                    className="sb-stallionName__icon hidden-sm-down"
                                />
                            );
                        }
                        return false;
                    })()}
            </span>
        );
    }
    return (<span>—</span>);
};

ColumnStallionName.propTypes = {
    rowData: PropTypes.object,
    data: PropTypes.string
};

export default ColumnStallionName;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnStallionName.js